import { useMediaQuery } from '@mui/material';

/**
 * Узкий экран: телефон или планшет в портретной ориентации.
 *
 * Граница совпадает с `md` у MUI и с медиазапросами `max-width: 899.95px`
 * в CSS (шапка, навигация, главная таблица, журнал) — менять её нужно везде сразу.
 *
 * Мобильная разметка включается только через этот флаг или те медиазапросы: десктоп
 * получает ровно те же пропсы, что и раньше, и правки под телефон его не задевают.
 *
 * noSsr — чтобы первый рендер на телефоне сразу шёл мобильным, без мелькания таблицы.
 */
export const MOBILE_QUERY = '(max-width:899.95px)';

const useIsMobile = () => useMediaQuery(MOBILE_QUERY, { noSsr: true });

/**
 * Пропсы диалога для телефона: стандартные поля по 32px съедают пятую часть
 * экрана, и формы из двух полей в строку перестают помещаться.
 */
export const mobileDialogProps = (isMobile) => (isMobile ? {
  PaperProps: { sx: { m: 1.5, width: 'calc(100% - 24px)', maxHeight: 'calc(100% - 24px)' } },
} : {});

export default useIsMobile;
